const raftUnits = {
  physicalStateOptions() {
    // Copied from \Drupal\chemdb_type\ChemdbHelper::physicalStates().
    // The options array needs to be the canonical data in JS because it
    // preserves the desired order, unlike object keys and values;
    return [
      { key: "S", label: "Solid" },
      { key: "L", label: "Liquid" },
      { key: "G", label: "Gas" },
      { key: "C", label: "Liquefied Gas" },
    ];
  },
  physicalStatesMap: null,
  physicalStates() {
    if (!this.physicalStatesMap) {
      this.physicalStatesMap = {};
      for (const option of this.physicalStateOptions()) {
        this.physicalStatesMap[option.key] = option.label;
      }
    }
    return this.physicalStatesMap;
  },
  unitOptions() {
    // Copied from \Drupal\chemdb_type\ChemdbHelper::units().
    return [
      { key: "g", label: "g" },
      { key: "kg", label: "kg" },
      { key: "ml", label: "ml" },
      { key: "l", label: "L" },
      { key: "cc", label: "CC" },
      { key: "cu_ft", label: "CU FT" },
      { key: "cylinder_large", label: "CYLINDER, LARGE" },
      { key: "cylinder_medium", label: "CYLINDER, MEDIUM" },
      { key: "cylinder_small", label: "CYLINDER, SMALL" },
      { key: "fl_oz", label: "Fl Oz" },
      { key: "gals", label: "gals" },
      { key: "lbs", label: "lbs" },
      { key: "mg", label: "mg" },
      { key: "ng", label: "ng" },
      { key: "oz", label: "Oz" },
      { key: "pt", label: "PT" },
      { key: "qt", label: "QT" },
      { key: "ton", label: "Ton" },
      { key: "ug", label: "µg" },
      { key: "ul", label: "µl" },
      { key: "unit", label: "UNIT" },
    ];
  },
  unitsMap: null,
  units() {
    if (!this.unitsMap) {
      this.unitsMap = {};
      for (const option of this.unitOptions()) {
        this.unitsMap[option.key] = option.label;
      }
    }
    return this.unitsMap;
  },
  weightsMeasures() {
    return [
      // Liters.
      { key: "l", label: "L" },
      // Grams.
      { key: "g", label: "g" },
    ];
  },
  getUnitLabel(unitKey, units = null) {
    if (!units) {
      units = this.unitOptions();
    }
    for (let i = 0; i < units.length; i++) {
      if (units[i].key === unitKey) {
        return units[i].label;
      }
    }
    return "";
  },
};

export default raftUnits;
